export default __webpack_public_path__ + "static/char-s-34-ja-183d65db5f5912a9d0f9bb07afe0c121.webp";